export default "__VITE_ASSET__Ge0QL8bY__"